import { useQuery } from '@tanstack/react-query';
import type { Tenant } from './types';
import { apiFetch, type Page } from './client';

/**
 * Feeds the property-create tenant picker. A single page (limit 100, the
 * API's max) is proportionate for a v1 internal admin tool — a real
 * multi-hundred-tenant deployment would need a searchable combobox instead,
 * not something to build ahead of the actual need.
 */
export function useTenantOptions() {
  return useQuery({
    queryKey: ['tenant-options'],
    queryFn: () => apiFetch<Page<Tenant>>('/v1/admin/tenants', { query: { limit: 100 } }),
  });
}
